"use strict";

exports.__esModule = true;
exports.useMemoWhenDefined = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useMemoWhenDefined = exports.useMemoWhenDefined = function useMemoWhenDefined(props) {
  var value = props.value,
    compute = props.compute,
    dependencies = props.dependencies;
  var _useState = (0, _react.useState)(),
    internalValue = _useState[0],
    setInternalValue = _useState[1];
  (0, _react.useEffect)(function () {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);
  return (0, _react.useMemo)(function () {
    if (internalValue !== undefined) {
      return compute(internalValue);
    }
  }, [internalValue].concat(dependencies));
};